import Phaser from 'phaser';

const BG_OUTER = 0x0a0f1f;
const BG_INNER = 0x052e16;
const BLADE = 0x86efac;
const BLADE_EDGE = 0x22c55e;
const HILT = 0xfde047;
const STROKE = 0xffffff;

export function drawDragonDagger(g: Phaser.GameObjects.Graphics, size: number) {
  g.clear();
  const pad = Math.max(4, Math.floor(size * 0.08));
  const r = (size - pad * 2) / 2;
  const stroke = Math.max(3, Math.floor(size * 0.06));

  g.lineStyle(stroke, STROKE, 1);
  g.fillStyle(BG_OUTER, 1);
  g.fillCircle(0, 0, r);
  g.strokeCircle(0, 0, r);

  g.fillStyle(BG_INNER, 1);
  g.fillCircle(0, 0, r * 0.88);

  const cos = Math.cos(-Math.PI / 4);
  const sin = Math.sin(-Math.PI / 4);

  const bladeLen = r * 1.1;
  const bladeMaxW = r * 0.3;
  const pts = [
    { x: -bladeLen / 2, y: -bladeMaxW / 2 },
    { x: bladeLen / 2 - bladeMaxW * 0.4, y: -bladeMaxW / 2 },
    { x: bladeLen / 2, y: -bladeMaxW * 0.1 },
    { x: bladeLen / 2, y: bladeMaxW * 0.1 },
    { x: bladeLen / 2 - bladeMaxW * 0.4, y: bladeMaxW / 2 },
    { x: -bladeLen / 2, y: bladeMaxW / 2 },
  ];
  const rotated = pts.map((p) => ({
    x: p.x * cos - p.y * sin,
    y: p.x * sin + p.y * cos,
  }));
  g.fillStyle(BLADE, 1);
  g.beginPath();
  g.moveTo(rotated[0].x, rotated[0].y);
  for (let i = 1; i < rotated.length; i++) g.lineTo(rotated[i].x, rotated[i].y);
  g.closePath();
  g.fillPath();
  g.lineStyle(2, BLADE_EDGE, 1);
  g.strokePath();

  const wingLen = r * 0.55;
  const wingW = r * 0.18;
  const wingPts1 = [
    { x: -bladeLen / 2 - r * 0.05, y: 0 },
    { x: -bladeLen / 2 - r * 0.05 + wingLen, y: -wingW * 1.4 },
    { x: -bladeLen / 2 - r * 0.05 + wingLen * 0.6, y: -wingW * 0.5 },
    { x: -bladeLen / 2 - r * 0.05 + wingLen * 0.3, y: -wingW * 0.3 },
  ];
  const wing1 = wingPts1.map((p) => ({
    x: p.x * cos - p.y * sin,
    y: p.x * sin + p.y * cos,
  }));
  g.fillStyle(HILT, 1);
  g.beginPath();
  g.moveTo(wing1[0].x, wing1[0].y);
  for (let i = 1; i < wing1.length; i++) g.lineTo(wing1[i].x, wing1[i].y);
  g.closePath();
  g.fillPath();
  g.lineStyle(2, 0x0a0f1f, 1);
  g.strokePath();

  const wingPts2 = [
    { x: -bladeLen / 2 - r * 0.05, y: 0 },
    { x: -bladeLen / 2 - r * 0.05 + wingLen, y: wingW * 1.4 },
    { x: -bladeLen / 2 - r * 0.05 + wingLen * 0.6, y: wingW * 0.5 },
    { x: -bladeLen / 2 - r * 0.05 + wingLen * 0.3, y: wingW * 0.3 },
  ];
  const wing2 = wingPts2.map((p) => ({
    x: p.x * cos - p.y * sin,
    y: p.x * sin + p.y * cos,
  }));
  g.fillStyle(HILT, 1);
  g.beginPath();
  g.moveTo(wing2[0].x, wing2[0].y);
  for (let i = 1; i < wing2.length; i++) g.lineTo(wing2[i].x, wing2[i].y);
  g.closePath();
  g.fillPath();
  g.lineStyle(2, 0x0a0f1f, 1);
  g.strokePath();

  const hiltLen = r * 0.45;
  const hiltW = r * 0.14;
  const hpts = [
    { x: -bladeLen / 2 - hiltLen, y: -hiltW / 2 },
    { x: -bladeLen / 2, y: -hiltW / 2 },
    { x: -bladeLen / 2, y: hiltW / 2 },
    { x: -bladeLen / 2 - hiltLen, y: hiltW / 2 },
  ];
  const hiltPts = hpts.map((p) => ({
    x: p.x * cos - p.y * sin,
    y: p.x * sin + p.y * cos,
  }));
  g.fillStyle(0x16a34a, 1);
  g.beginPath();
  g.moveTo(hiltPts[0].x, hiltPts[0].y);
  for (let i = 1; i < hiltPts.length; i++) g.lineTo(hiltPts[i].x, hiltPts[i].y);
  g.closePath();
  g.fillPath();
  g.lineStyle(2, 0x0a0f1f, 1);
  g.strokePath();
}
